/**
 * Browser-Storage mit Instanz-Praefix (TQ #409, SPEC-Cockpit-pro-Kunde §4.1 a).
 *
 * Pfad-Instanzen teilen sich das Origin cockpit.it-sce.de; localStorage/sessionStorage sind je
 * Origin. Darum bekommt jeder Schluessel in der Pfad-Instanz das Praefix `<kennung>:`.
 * Legacy-Cockpit (ohne Kennung): Praefix '' = Schluessel wie bisher, keine Migration noetig.
 * Alle Aufrufe im org-portal laufen ueber diese Helper, nie direkt ueber window.*Storage.
 */
import { currentPathTenant, type PathTenant } from './tenantPath'

export function storagePrefix(t: PathTenant = currentPathTenant()): string {
  return t.kind === 'instance' ? `${t.id}:` : ''
}

export function scopedKey(key: string, t: PathTenant = currentPathTenant()): string {
  return `${storagePrefix(t)}${key}`
}

export interface ScopedStorage {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

function scoped(get: () => Storage): ScopedStorage {
  return {
    getItem: (key) => get().getItem(scopedKey(key)),
    setItem: (key, value) => get().setItem(scopedKey(key), value),
    removeItem: (key) => get().removeItem(scopedKey(key)),
  }
}

/** localStorage mit Instanz-Praefix. Nie fuer Tokens (§4.1 b). */
export const scopedLocalStorage: ScopedStorage = scoped(() => window.localStorage)
/** sessionStorage mit Instanz-Praefix. */
export const scopedSessionStorage: ScopedStorage = scoped(() => window.sessionStorage)

/**
 * Optionen fuer den KeycloakAuthProvider: in der Pfad-Instanz Praefix, kein Access-Token in
 * localStorage und Logout zurueck auf den Instanz-Pfad (nicht auf die Origin-Wurzel = Legacy).
 * Legacy: unveraendert (kein Praefix, Legacy-Kopie access_token bleibt, Logout auf Origin).
 */
export function authStorageProps(t: PathTenant = currentPathTenant(), origin = window.location.origin): {
  storageKeyPrefix: string
  accessTokenInLocalStorage: boolean
  logoutRedirectUri?: string
} {
  if (t.kind !== 'instance') return { storageKeyPrefix: '', accessTokenInLocalStorage: true }
  return { storageKeyPrefix: storagePrefix(t), accessTokenInLocalStorage: false, logoutRedirectUri: `${origin}${t.basePath}/` }
}
